import React, { Component } from 'react';
import { t } from "i18next";

import { userActions } from 'redux/_actions';
import { connect } from 'react-redux';
import { Button, Row, Col, Spinner } from 'reactstrap';
import { HOUR_TIME, toSimpleDate, toSimpleTime } from 'utils/Utils';
import Checkbox from 'components/Checkbox';
import { invokeHttpsApi } from 'utils/API';

class DeliveryDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            activeTab: 0,
            dropoff: {},
            items: {},
            openedItems: {},
            stores: {},
            createItem: {
                helperCount: 1
            },
        };
    }

    submitCompleted(update) {
        const {delivery, onCloseClick} = this.props;
        this.setState({progress: true});
        invokeHttpsApi("delivery-submitDeliveryCompleted", 
        {
            deliveryId: delivery.id,
            update: update,
        }, 
        ((data)=> {
            if (data && data.success) {
                alert(t('change_success'));
                this.setState({progress: false});
                if (onCloseClick) {
                    onCloseClick(update)
                }
            } else {
                alert(t('change_failure'));
                this.setState({progress: false});
            }
        }), ((error)=> {
            alert(t('change_failure') + error);
            this.setState({progress: false});
        }))
    }

    renderCustomerInfo() {
        const {delivery} = this.props;
        if (!delivery.customer) {
            delivery.customer = {};
        }

        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('customer_information')}</h3>
                </div>
                <div className='detail-item'>
                    <h4 className='detail-title'>{t('firstname')}</h4>
                    <div className='detail-label'>{delivery.customer.firstName}</div>
                </div>
                <div className='detail-item'>
                    <h4 className='detail-title'>{t('lastname')}</h4>
                    <div className='detail-label'>{delivery.customer.lastname}</div>
                </div>
                <div className='detail-item'>
                    <h4 className='detail-title'>{t('phone')}</h4>
                    <div className='detail-label'>{delivery.customer.phone}</div>
                </div>
                <div className='detail-item'>
                    <h4 className='detail-title'>{t('email')}</h4>
                    <div className='detail-label'>{delivery.customer.email}</div>
                </div>
            </div>
        )
    }

    renderLocationInfo() {
        const {delivery} = this.props;
        if (!delivery.location) {
            delivery.location = {};
        }
        if (!delivery.location.store) {
            delivery.location.store = {};
        }
        if (!delivery.location.dropoff) {
            delivery.location.dropoff = {};
        }

        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('locations')}</h3>
                </div>
                
                <div className='input-item'>
                    <h4 className='input-label'>{t('your_store')}</h4>
                    <div className='wrap-content-parent book-item-view'>
                        <div className='wrap-content-fill-child input-label'>
                            {delivery.location.store.name}
                        </div>
                    </div>
                </div>
                
                <div className='input-item'>
                    <h4 className='input-label'>{t('drop_off_address')}</h4>
                </div>
                
                <div className='wrap-content-parent book-item-view'>
                    <div className='wrap-content-fill-child input-label'>
                        {delivery.location.dropoff.name}
                    </div>
                    
                </div>
                <div className='book-info-layout'>
                    <div className='detail-item-l'>
                        <h4 className='info-label-l'>{t('address')}</h4>
                        <div className='info-label'>{delivery.location.dropoff.formatted_address}</div>
                    </div>

                    <div className='detail-item'>
                        <Checkbox 
                            label={t('need_stairs')}
                            isChecked={delivery.location.dropoff.needStairs} />
                    </div>
                    <div className='detail-item'>
                        <Checkbox 
                            label={t('breakdown_title')}
                            isChecked={delivery.location.dropoff.breakdownRequired} />
                    </div>
                    
                    <div className='detail-item-l'>
                        <h4 className='info-label-l'>{t('unit_number')}</h4>
                        <div className='info-label'>{delivery.location.dropoff.unitNumber}</div>
                    </div>

                    <div className='detail-item-l'>
                        <h4 className='info-label-l'>{t('parking_info')}</h4>
                        <div className='info-label'>{delivery.location.dropoff.parkingInfo}</div>
                    </div>
                    
                </div>
            </div>
        )
    }

    renderItemDetail(item) {
        const { openedItems } = this.state;
        return (
            <div className='book-info-layout'>
                <div className='detail-item'>
                    <h4 className='detail-title'>{t('title')}</h4>
                    <div className='detail-label'>
                        {item.title} (Qty = {item.count})
                        <Checkbox 
                            label={t('full_assembly_title')}
                            isChecked={item.assemblyFull} />
                        <Checkbox 
                            label={t('breakdown_title')}
                            isChecked={item.breakdownRequired} />
                    </div>
                </div>
                {item.photos && (
                <div className='detail-label'>
                    {t('item_photos')}
                </div>
                )}
                {item.photos && (
                <div className='detail-item'>
                    <Row className='text-center' style={{marginTop: 10, marginBottom: 0, marginLeft: 0, marginRight: 0}}>
                        {Object.values(item.photos).map((item,idx) => (
                            <Col key={idx} xs={6} sm={3}>
                                <img src={item.photoUri} alt="RECEIPT" style={{margin: '10px 0px', width: '100%'}} />
                            </Col>
                        ))}
                    </Row>
                </div>
                )}
                {item.photoUri && (
                <div className='detail-label'>
                    {t('receipt_photo')}
                </div>
                )}
                {item.photoUri && (
                <div className='detail-item'>
                    <div className='text-center'>
                        <img src={item.photoUri} alt="RECEIPT" style={{width: '50%'}} />
                    </div>
                </div>
                )}
                {item.details && (
                <div>
                    <div className='detail-item'>
                        <h4 className='detail-title'>{t('width_placeholder')}</h4>
                        <div className='detail-label'>{item.details.width}</div>
                    </div>
                    <div className='detail-item'>
                        <h4 className='detail-title'>{t('height_placeholder')}</h4>
                        <div className='detail-label'>{item.details.height}</div>
                    </div>
                    <div className='detail-item'>
                        <h4 className='detail-title'>{t('depth_placeholder')}</h4>
                        <div className='detail-label'>{item.details.depth}</div>
                    </div>
                    <div className='detail-item'>
                        <h4 className='detail-title'>{t('weight_placeholder')}</h4>
                        <div className='detail-label'>{item.details.weight}</div>
                    </div>
                    <div className='detail-item'>
                        <h4 className='detail-title'>{t('other_placeholder')}</h4>
                        <div className='detail-label'>{item.details.other}</div>
                    </div>
                </div>
                )}
                <div className='wrap-content-parent'>
                    <div className='wrap-content-fill-child' />
                    
                    <Button className='btn-cancel' onClick={e=> {
                        delete openedItems[item.id];
                
                        this.setState({openedItems: openedItems});
                    }}>{t('close')}</Button>
                </div>
            </div>
        )
    }

    renderItems() {
        const {delivery} = this.props;
        const {openedItems} = this.state;
        if (!delivery.items) {
            delivery.items = {};
        }

        let viewArr = [];
        for (const item of Object.values(delivery.items)) {
            viewArr.push(
                <div style={{marginBottom: 5}}>
                    <div className='book-item-view wrap-content-parent'>
                        {item.title} (Qty = {item.count})
                        {item.photoUri && (<img src={item.photoUri} alt='receipt' style={{height: 30, margin: '0px 10px'}} />)}
                        <div className='wrap-content-fill-child' />
                        <div className='wrap-content-fill-child' />
                        
                        <Button className='btn-submit' onClick={e=> {
                            openedItems[item.id] = item.id;
                    
                            this.setState({openedItems: openedItems});
                        }}>{t('details')}</Button>
                    </div>
                    {openedItems[item.id] && this.renderItemDetail(item)}
                </div>
            )
        }
        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('items')}</h3>
                </div>
                {viewArr}
            </div>
        )
    }

    renderOrderId() {
        const {delivery} = this.props;
        
        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('order_id')}</h3>
                </div>
                <div className='input-item'>
                    <div className='info-label'>{delivery.orderId}</div>
                </div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('hfc_id')}</h3>
                </div>
                <div className='input-item'>
                    <div className='info-label'>{delivery.hfcId}</div>
                </div>
            </div>
        );
    }

    renderNote() {
        const {delivery} = this.props;
        
        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('optional_notes')}</h3>
                </div>
                <div className='input-item'>
                    <div className='info-label'>{delivery.note}</div>
                </div>
            </div>
        );
    }

    renderDateTime() {
        const {delivery} = this.props;
        
        if (!delivery.deadline) {
            return <div/>;
        }
        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('date_time')}</h3>
                </div>
                <div className='input-item'>
                    <div className='info-label'>{t('book_date_text_details')}</div>
                    <div className='input-item'>
                        <h4 className='info-label-l'>
                            {t('book_date_label')}:  {delivery.deadline ? toSimpleDate(delivery.deadline) : ""}
                        </h4>
                    </div>
                    <div className='input-item'>
                        <h4 className='info-label-l'>
                            {t('book_time_label')}: {delivery.deadline ? (toSimpleTime(delivery.deadline) + " ~ " + toSimpleTime(delivery.deadline + 4 * HOUR_TIME)) : ""}
                        </h4>
                    </div>
                    {delivery.deadlineTo && (
                    <div className='input-item'>
                        <h4 className='info-label-l'>
                            {t('book_time_1_label')}: {delivery.deadlineTo ? (toSimpleTime(delivery.deadlineTo) + " ~ " + toSimpleTime(delivery.deadlineTo + 4 * HOUR_TIME)) : ""}</h4>
                    </div>
                    )}
                </div>
            </div>
        );
    }

    renderPayment() {
        const {delivery, deliveryPayments} = this.props;

        let paid = false;
        for (const item of Object.values(deliveryPayments)) {
            if (item.deliveryId === delivery.id && item.success) {
                paid = true;
            }
        }
        
        return (
            <div>
                <div className='book-item-subtitle'>
                    <h3 className='book-item-header'>{t('payment')}</h3>
                </div>
                <div className='input-item'>
                    <h3>{t('price')}: $<span style={{color: '#fa616a'}}>{delivery.price}</span> </h3>
                    <h3 style={{fontSize: 15, color: paid ? '#2CCB6A' : '#fa616a'}}>
                        {paid ? t('payment_success') : t(delivery.paid !== false ? 'payment_no' : 'payment_failure')}
                    </h3>
                </div>
            </div>
        );
    }

    render() {
        const {delivery} = this.props;
        const {progress} = this.state;

        return (
            <div className='book-container'>
                <div className='book_notation'>{t('delivery_detail')}</div>
                <Row>
                    <Col sm={6} xs={12}>
                    {this.renderCustomerInfo()}
                    {this.renderLocationInfo()}
                    {this.renderOrderId()}
                    {this.renderDateTime()}
                    </Col>
                    <Col sm={6} xs={12}>
                    {this.renderItems()}
                    {delivery.note && this.renderNote()}
                    {this.renderPayment()}
                    </Col>
                </Row>
                
                <div className='wrap-content-parent'>
                    <div className='wrap-content-fill-child' />
                    {progress ? (
                    <Spinner size="nm" color="primary" />
                    ) : (
                    <Button className='btn-normal' onClick={e=> {
                        this.submitCompleted(delivery.completed ? false : true);
                    }}>
                        {t(delivery.completed ? 'delivery_not_completed' : 'delivery_completed')}
                    </Button>
                    )}
                </div>
            </div>
        );
    }
}

function mapState(state) {
    const { isAdmin, loggingIn, user, redirectTo } = state.authentication;
    return { isAdmin, loggingIn, user, redirectTo };
}

const actionCreators = {
    login: userActions.login,
    logout: userActions.logout,
    setAuthRedirect: userActions.setAuthRedirect,
};

const connectedDeliveryDetails = connect(mapState, actionCreators)(DeliveryDetails);
export { connectedDeliveryDetails as DeliveryDetails };
